<template>
  <div class="log-detail">
    <el-page-header @back="goBack" content="日志详情"></el-page-header>
    <el-row class="mar">
      <el-col :span="6">新增时间：{{this.startTime}}</el-col>
      <el-col :span="12">途径：{{this.operateSubType}}</el-col>
    </el-row>
     <Table :list="list" :pages="pages" @search="fetch_operatorLogDetail"/>
  </div>
</template>

<script>
import Table from './table.vue'
import { getProductEditLogDetail} from '@servers/prod/log/index'
import { mapGetters, mapActions} from 'vuex'

export default {
  components: {
    Table
  },
  props: ['id','operateSubType','startTime'],
  data() {
    return {
      activeName: 'all',
      list: [],
      info: '',
      pages: {
          total: 0,
          pageNo: 1,
          pageSize: 20,
      },
      status: null
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    async fetch_operatorLogDetail(page) {
      const res = await getProductEditLogDetail({editLogId: this.id, pageNo: page.pageNo || 1, pageSize: page.pageSize || 20});
      if(!res) return;
      this.list = res;
      // this.pages.total = res.total;
      // this.pages.pageNo=page.pageNo || 1; 
      // this.pages.pageSize=page.pageSize || 20;
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.pages.pageNo=1;
      let status=null;
      switch (tab.name) {
        case 'all':
          status=null
          break;
        case 'sucess':
          status=1
          break;
        case'fail':
          status=0;
          break;
        default:
          status=null
          break;
      }
      this.status = status;
      this.fetch_operatorLogDetail(this.pages)
    }
  },
  mounted() {
    if(this.id) {
      this.fetch_operatorLogDetail(this.pages)
    }
  }

}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}

</style>
